function CHFrFAQBody() {
  return (
    <>
      <div className="container-fluid  p-4 body-font">
        <div
          className="row p-4"
          style={{
            width: "100vw",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="row img-fluid"
            style={{
              backgroundImage:
                "url(https://images.hertz.com/content/dam/hod/images/en-gb/static/FAQ_top.png)",
              backgroundSize: "cover",
            }}
          >
            <div className="col-xs-12 col-md-1"></div>
            <div className="col-xs-12 col-md-5">
              <br />
              <p className="h6">
                <b>FAQs</b>
              </p>
              <p className="h1">
                <b>En savoir plus</b>
              </p>
              <p>
                Nous comprenons que vous puissiez avoir des questions sur le
                fonctionnement de Hertz 24/7, des préoccupations concernant vos
                factures, ou que vous souhaitiez simplement savoir ce qui est
                nécessaire pour vous inscrire. Cette page répondra à ces
                questions.
              </p>

              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <div className="col-xs-12 col-md-4"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <br />
            <br />

            <p>
              <a href="#reg" style={{ textDecoration: "none" }}>
                Inscription
              </a>
            </p>
            <hr />
            <p>
              <a href="#book" style={{ textDecoration: "none" }}>
                Votre réservation
              </a>
            </p>
            <hr />
            <p>
              <a href="#yj" style={{ textDecoration: "none" }}>
                Votre location
              </a>
            </p>
            <hr />
            <p>
              <a href="#bfi" style={{ textDecoration: "none" }}>
                Facturation, frais et assurance
              </a>
            </p>
            <hr />
            <p>
              <a href="#consup" style={{ textDecoration: "none" }}>
                Contacter le support
              </a>
            </p>
            <hr />
            <p>
              <a href="#aob" style={{ textDecoration: "none" }}>
                Accidents/Pannes
              </a>
            </p>
            <hr />
            <p>
              <a href="#cg" style={{ textDecoration: "none" }}>
                Règles
              </a>
            </p>
            <hr />
          </div>

          <div className="col-xs-12 col-md-9" style={{ textAlign: "left" }}>
            <br />
            <br />

            <div className="accordion p-4" id="accordionFlushExample">
              <br />
              <p id="reg">
                <b>Inscription</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse1"
                    aria-expanded="false"
                    aria-controls="flush-collapse1"
                  >
                    <b>Qu’est-ce que Hertz 24/7 ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Hertz 24/7® est le service d’autopartage de Hertz, qui vous
                    offre confort et flexibilité pour accéder à une large gamme
                    d’utilitaires et de véhicules. Vous pouvez louer à l’heure
                    ou à la journée. La prise en charge est disponible 24h/24 et
                    7j/7 (selon les horaires d’ouverture de chaque site). Avec
                    Hertz 24/7, vous pouvez facilement réserver et gérer votre
                    location via l’application. Notre objectif est que vous
                    puissiez prendre la route dans les 15 minutes suivant le
                    téléchargement de l’application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse2"
                    aria-expanded="false"
                    aria-controls="flush-collapse2"
                  >
                    <b>De quoi ai-je besoin pour utiliser Hertz 24/7 ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading2"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Pour utiliser Hertz 24/7, nous avons besoin des éléments
                    suivants :
                    <br />
                    · un permis de conduire valide et une pièce d’identité à
                    votre nom (ou un passeport accompagné d’un justificatif de
                    domicile)
                    <br />
                    · une carte de crédit/débit ou un compte PayPal à votre nom
                    <br />
                    · votre numéro de téléphone portable et votre adresse e-mail
                    personnelle
                    <br />
                    Lors de l’inscription, nous effectuons des vérifications
                    d’identité avant de confirmer votre compte.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse3"
                    aria-expanded="false"
                    aria-controls="flush-collapse3"
                  >
                    <b>Comment savoir si mon inscription est terminée ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Une fois votre inscription finalisée, nous vous enverrons
                    une notification push ainsi qu’un e-mail.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse4"
                    aria-expanded="false"
                    aria-controls="flush-collapse4"
                  >
                    <b>Que faire si mes coordonnées changent ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez modifier vos coordonnées à tout moment dans
                    l’application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse5"
                    aria-expanded="false"
                    aria-controls="flush-collapse5"
                  >
                    <b>Mon adhésion expire-t-elle ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Votre adhésion est illimitée tant que votre permis de
                    conduire reste valide et que vous respectez les conditions
                    de location.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading7">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse7"
                    aria-expanded="false"
                    aria-controls="flush-collapse7"
                  >
                    <b>Quel âge dois-je avoir pour louer un véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse7"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading7"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Âge minimum requis Vous devez avoir au moins 19 ans et être
                    titulaire d’un permis de conduire valide depuis au moins un
                    an.
                  </div>
                </div>
              </div>

              <br />
              <p id="book">
                <b>Votre réservation</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading9">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse9"
                    aria-expanded="false"
                    aria-controls="flush-collapse9"
                  >
                    <b>
                      Que se passe-t-il si le véhicule souhaité n’est pas
                      disponible ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse9"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading9"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Si le véhicule n’est pas disponible, des créneaux
                    alternatifs ou des emplacements à proximité vous seront
                    proposés.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading10">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse10"
                    aria-expanded="false"
                    aria-controls="flush-collapse10"
                  >
                    <b>Comment savoir si ma réservation est confirmée ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse10"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading10"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez vérifier le statut dans l’application et vous
                    recevrez également un e-mail de confirmation.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading11">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse11"
                    aria-expanded="false"
                    aria-controls="flush-collapse11"
                  >
                    <b>Puis-je modifier ou annuler ma réservation ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse11"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading11"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez modifier ou annuler gratuitement avant l’heure
                    de prise en charge. Des frais peuvent s’appliquer en cas
                    d’annulation pendant la période réservée.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading12">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse12"
                    aria-expanded="false"
                    aria-controls="flush-collapse12"
                  >
                    <b>Mon paiement est-il sécurisé ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse12"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading12"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    J Oui. Nous utilisons Stripe, qui respecte les normes de
                    sécurité les plus strictes (conforme PCI DSS).
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading13">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse13"
                    aria-expanded="false"
                    aria-controls="flush-collapse13"
                  >
                    <b>Comment les frais sont-ils calculés ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse13"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading13"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Avant le début de la location, nous bloquons 150 % du
                    montant estimé (minimum 150 €) comme caution. Ce montant
                    n’est pas débité. Après la location, nous déduisons le coût
                    final et remboursons le reste. Des frais supplémentaires
                    peuvent être facturés séparément.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading14">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse14"
                    aria-expanded="false"
                    aria-controls="flush-collapse14"
                  >
                    <b>Combien de temps à l’avance puis-je réserver ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse14"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading14"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Entre 3 et 6 mois à l’avance selon le site.
                  </div>
                </div>
              </div>

              <br />
              <p id="yj">
                <b>Votre location</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading15">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse15"
                    aria-expanded="false"
                    aria-controls="flush-collapse15"
                  >
                    <b>Comment déverrouiller le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse15"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading15"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Utilisez l’application comme clé digitale. Rendez-vous dans
                    l’onglet « Conduire » et appuyez sur « Déverrouiller ».
                    Assurez-vous que votre location a commencé, que l’inspection
                    est terminée et que le Bluetooth est activé. Vous devez être
                    à moins de 5 mètres du véhicule.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading16">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse16"
                    aria-expanded="false"
                    aria-controls="flush-collapse16"
                  >
                    <b>Où se trouvent les clés ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse16"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading16"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Les clés se trouvent dans la boîte à gants et doivent y être
                    remises à la fin de la location.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading17">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse17"
                    aria-expanded="false"
                    aria-controls="flush-collapse17"
                  >
                    <b>Comment démarrer le véhicule ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse17"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading17"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Pour les véhicules avec contact, vous trouverez la clé dans
                    le support de clé dans la boîte à gants. Appuyez sur la
                    pédale de frein et d’embrayage (pour les véhicules
                    automatiques, uniquement la pédale de frein), puis appuyez
                    sur le bouton de démarrage ou démarrez le moteur avec la
                    clé. Si le véhicule ne démarre pas, l’antidémarrage peut
                    être activé. Appuyez sur le bouton « Power » sur l’écran de
                    conduite dans l’application Hertz 24/7 (entre «
                    Déverrouiller » et « Verrouiller ») pour le désactiver. Le
                    véhicule devrait alors démarrer. Remarque : certains
                    véhicules électriques, comme Tesla ou Polestar, n’ont pas de
                    bouton de démarrage distinct.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading18">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse18"
                    aria-expanded="false"
                    aria-controls="flush-collapse18"
                  >
                    <b>Que se passe-t-il si le véhicule ne démarre pas ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse18"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading18"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Le véhicule dispose d’une fonction de sécurité qui active
                    l’antidémarrage si le contact est coupé pendant plus de 2
                    minutes. Pour redémarrer le moteur, retirez la clé du
                    contact et utilisez l’application pour désactiver
                    l’antidémarrage en appuyant sur l’icône « Power » sur
                    l’écran de conduite. Vous pouvez également verrouiller et
                    déverrouiller le véhicule via l’application. Si le véhicule
                    ne démarre toujours pas, veuillez contacter notre service
                    client.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading19">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse19"
                    aria-expanded="false"
                    aria-controls="flush-collapse19"
                  >
                    <b>Comment trouver le véhicule ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse19"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading19"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Votre confirmation de réservation contient les informations
                    permettant de localiser le véhicule. Ces informations sont
                    également disponibles dans l’application. Une fois votre
                    véhicule prêt, vous pouvez le localiser grâce à la fonction
                    « Localiser le véhicule ».
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading20">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse20"
                    aria-expanded="false"
                    aria-controls="flush-collapse20"
                  >
                    <b>Que faire si le véhicule réservé n’est pas là ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse20"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading20"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez utiliser la fonction « Localiser le véhicule » pour
                    le trouver. Si vous ne parvenez toujours pas à le localiser,
                    veuillez contacter le service client.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading21">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse21"
                    aria-expanded="false"
                    aria-controls="flush-collapse21"
                  >
                    <b>Que se passe-t-il si je rends le véhicule en retard ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse21"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading21"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Si vous pensez être en retard, veuillez prolonger votre
                    location via l’application. Cela n’est possible que s’il n’y
                    a pas de réservation suivante et si le site est encore
                    ouvert. Si vous dépassez la durée réservée sans
                    prolongation, des frais supplémentaires et une pénalité de
                    retard seront facturés.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading22">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse22"
                    aria-expanded="false"
                    aria-controls="flush-collapse22"
                  >
                    <b>
                      Que se passe-t-il si je récupère le véhicule en retard ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse22"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading22"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez récupérer le véhicule à tout moment pendant la
                    période réservée. Toutefois, la durée initialement réservée
                    sera facturée.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading23">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse23"
                    aria-expanded="false"
                    aria-controls="flush-collapse23"
                  >
                    <b>Qui prend en charge le carburant ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse23"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading23"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Le carburant n’est pas inclus. Le véhicule doit être
                    restitué avec le plein. Des exceptions peuvent s’appliquer
                    pour les véhicules électriques.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading24">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse24"
                    aria-expanded="false"
                    aria-controls="flush-collapse24"
                  >
                    <b>
                      Que faire si le réservoir n’est pas plein lors de la prise
                      en charge ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse24"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading24"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez tout de même restituer le véhicule avec le plein et
                    nous envoyer le reçu de carburant. Nous vous rembourserons
                    la différence.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse30"
                    aria-expanded="false"
                    aria-controls="flush-collapse30"
                  >
                    <b>Fournissez-vous des sièges enfants ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse30"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading30"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non, mais vous pouvez utiliser les vôtres.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse31"
                    aria-expanded="false"
                    aria-controls="flush-collapse31"
                  >
                    <b>Les animaux sont-ils autorisés ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse31"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading31"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non, sauf les chiens d’assistance.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading34">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse34"
                    aria-expanded="false"
                    aria-controls="flush-collapse34"
                  >
                    <b>Puis-je restituer le véhicule plus tôt ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse34"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading34"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui, mais la totalité de la période réservée sera facturée.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading35">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse35"
                    aria-expanded="false"
                    aria-controls="flush-collapse35"
                  >
                    <b>Comment puis-je prolonger ma location ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse35"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading35"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Selon la disponibilité du véhicule, vous pouvez facilement
                    prolonger votre location via l’application Hertz 24/7. Il
                    suffit de suivre les étapes après avoir sélectionné «
                    Prolonger la location ».
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading36">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse36"
                    aria-expanded="false"
                    aria-controls="flush-collapse36"
                  >
                    <b>Où dois-je restituer le véhicule ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse36"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading36"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez restituer le véhicule sur l’emplacement de parking
                    Hertz 24/7 prévu sur le site. S’il n’y a pas de place
                    désignée, merci de le ramener à l’endroit où vous l’avez
                    récupéré.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading37">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse37"
                    aria-expanded="false"
                    aria-controls="flush-collapse37"
                  >
                    <b>
                      Que faire si la place de stationnement attribuée est déjà
                      occupée ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse37"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading37"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez garer le véhicule aussi près que possible de la
                    place attribuée.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading38">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse38"
                    aria-expanded="false"
                    aria-controls="flush-collapse38"
                  >
                    <b>
                      Que se passe-t-il si le véhicule que j’ai réservé est
                      restitué en retard par le client précédent ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse38"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading38"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nous ferons toujours de notre mieux pour vous prévenir à
                    l’avance. Toutefois, si vous n’avez pas de nouvelles,
                    veuillez nous contacter dès que possible et nous
                    organiserons un véhicule alternatif.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading39">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse39"
                    aria-expanded="false"
                    aria-controls="flush-collapse39"
                  >
                    <b>
                      Dois-je utiliser les clés pour verrouiller ou
                      déverrouiller le véhicule ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse39"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading39"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. Si vous le faites, cela peut entraîner des problèmes
                    pendant votre location. Les clés doivent rester dans le
                    véhicule à tout moment. Veuillez utiliser l’application
                    Hertz 24/7 pour verrouiller et déverrouiller le véhicule
                    pendant votre location. Remarque : l’antidémarrage peut
                    s’activer en cas d’inactivité. Pour le désactiver, appuyez
                    sur le bouton « Power » sur l’écran « Conduire » de
                    l’application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading40">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse40"
                    aria-expanded="false"
                    aria-controls="flush-collapse40"
                  >
                    <b>Comment vos véhicules sont-ils entretenus ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse40"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading40"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Une équipe de professionnels dédiés s’occupe de notre flotte
                    Hertz 24/7. En plus de l’entretien régulier, nous effectuons
                    chaque mois un contrôle qualité en 40 points sur chaque
                    véhicule.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading41">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse41"
                    aria-expanded="false"
                    aria-controls="flush-collapse41"
                  >
                    <b>Que faire en cas de panne ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse41"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading41"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez nous contacter en cas de panne. Vous trouverez les
                    coordonnées dans l’application sous Aide → Contact.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading44">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse44"
                    aria-expanded="false"
                    aria-controls="flush-collapse44"
                  >
                    <b>Puis-je utiliser Hertz 24/7 dans d’autres pays ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse44"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading44"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui. Une fois inscrit, vous pouvez utiliser Hertz 24/7 dans
                    tous les sites participants aux États-Unis, au Royaume-Uni,
                    en France, en Allemagne, en Belgique, en Italie et au
                    Portugal.
                  </div>
                </div>
              </div>

              <br />
              <p id="bfi">
                <b>Facturation, frais et assurance</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading47">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse47"
                    aria-expanded="false"
                    aria-controls="flush-collapse47"
                  >
                    <b>Y a-t-il des frais supplémentaires à prévoir ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse47"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading47"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Des frais supplémentaires, comme les coûts liés aux
                    kilomètres ou à l’assurance, sont affichés lors du processus
                    de réservation. D’autres frais, tels que les frais de retard
                    ou de non-remplissage du réservoir, sont détaillés dans nos
                    conditions d’utilisation.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading49">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse49"
                    aria-expanded="false"
                    aria-controls="flush-collapse49"
                  >
                    <b>Dois-je payer une franchise ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse49"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading49"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    En cas de dommage, de perte ou de vol du véhicule, vous
                    devrez payer une franchise conformément à l’assurance
                    choisie lors de la réservation. Si le coût des réparations
                    est inférieur à la franchise, nous vous rembourserons la
                    différence, déduction faite des frais administratifs.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading50">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse50"
                    aria-expanded="false"
                    aria-controls="flush-collapse50"
                  >
                    <b>Que couvre l’assurance de ma réservation ? </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse50"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading50"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    L’assurance couvre les dommages au véhicule au-delà de la
                    franchise. La franchise est le montant maximum que vous
                    devez payer en cas de sinistre, à condition de respecter les
                    conditions de votre contrat de location. Vous êtes également
                    couvert par l’assurance responsabilité civile, incluse par
                    défaut et obligatoire. Elle couvre les dommages causés à
                    d’autres véhicules, biens et personnes en cas d’accident. Si
                    la perte, le dommage ou le vol du véhicule est causé
                    intentionnellement, ou si vous utilisez un mauvais carburant
                    ou contaminez le réservoir de carburant ou d’AdBlue, cela
                    sera considéré comme une négligence grave.
                  </div>
                </div>
              </div>

              <br />
              <p id="consup">
                <b>Contacter le support</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse29"
                    aria-expanded="false"
                    aria-controls="flush-collapse29"
                  >
                    <b>
                      Que faire si je trouve un objet dans le véhicule ou si j’y
                      oublie quelque chose ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse29"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading29"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Aucun problème. Contactez simplement notre équipe et nous
                    vous aiderons à récupérer vos effets personnels. Si un objet
                    est trouvé, nous contacterons le client précédent.
                  </div>
                </div>
              </div>

              <br />
              <p id="aob">
                <b>Accidents/Pannes</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse27"
                    aria-expanded="false"
                    aria-controls="flush-collapse27"
                  >
                    <b>
                      Que se passe-t-il si je reçois une amende (excès de
                      vitesse ou stationnement) ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Les péages, amendes et pénalités sont à votre charge et
                    doivent être payés par vous.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading42">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse42"
                    aria-expanded="false"
                    aria-controls="flush-collapse42"
                  >
                    <b>Que dois-je faire en cas d’accident ou d’incident ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse42"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading42"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    En cas d’accident, vous devez contacter la police. Ensuite,
                    contactez immédiatement l’équipe Hertz 24/7 via les
                    coordonnées dans la section « Aide » de l’application. Nous
                    nous occuperons du reste. Assurez-vous de recueillir les
                    informations du tiers impliqué et de prendre des photos des
                    dommages sur les deux véhicules. Le fait de ne pas signaler
                    un incident peut entraîner l’annulation de votre couverture
                    d’assurance.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading43">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse43"
                    aria-expanded="false"
                    aria-controls="flush-collapse43"
                  >
                    <b>Que dois-je faire en cas de vol du véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse43"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading43"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    En cas de vol, contactez-nous immédiatement via les
                    coordonnées dans l’application sous Aide → Contact.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading45">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse45"
                    aria-expanded="false"
                    aria-controls="flush-collapse45"
                  >
                    <b>
                      Dois-je payer si le véhicule est remorqué ou immobilisé ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse45"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading45"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nous réglerons d’abord les frais de remorquage et les
                    pénalités, puis nous vous les refacturerons avec des frais
                    administratifs.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading46">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse46"
                    aria-expanded="false"
                    aria-controls="flush-collapse46"
                  >
                    <b>Dois-je payer des frais de retard en cas de panne ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse46"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading46"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. En cas de panne, vous ne supporterez pas de frais
                    supplémentaires (sauf si vous êtes responsable de la panne).
                    L’assistance dépannage 24h/24 est incluse dans votre
                    réservation.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading48">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse48"
                    aria-expanded="false"
                    aria-controls="flush-collapse48"
                  >
                    <b>
                      Mon assurance automobile personnelle couvre-t-elle les
                      dommages ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse48"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading48"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. Votre assurance automobile personnelle ne s’applique
                    pas aux véhicules Hertz 24/7. Ceux-ci sont uniquement
                    couverts par les assurances incluses dans votre réservation.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading51">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse51"
                    aria-expanded="false"
                    aria-controls="flush-collapse51"
                  >
                    <b>
                      Puis-je me fier à l’assurance de ma carte bancaire pour
                      couvrir les dommages ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse51"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading51"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nous vous conseillons de vérifier auprès de votre
                    fournisseur de carte avant de réserver, car les niveaux de
                    couverture varient selon les cartes.
                  </div>
                </div>
              </div>

              <br />
              <p id="cg">
                <b>Règles</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading32">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse32"
                    aria-expanded="false"
                    aria-controls="flush-collapse32"
                  >
                    <b>Dois-je nettoyer le véhicule avant de le restituer ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse32"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading32"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui. Veuillez vous assurer que l’intérieur du véhicule est
                    propre à la fin de votre location, pour le prochain client.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading33">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse33"
                    aria-expanded="false"
                    aria-controls="flush-collapse33"
                  >
                    <b>
                      Que faire si le véhicule n’est pas propre à l’intérieur ou
                      à l’extérieur ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse33"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading33"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nous demandons à nos clients de laisser le véhicule propre
                    et en ordre après chaque location. Nos véhicules sont
                    également nettoyés régulièrement. Toutefois, si vous n’êtes
                    pas satisfait de son état, merci de nous en informer. Vous
                    pouvez aussi utiliser la fonction « Signaler un problème »
                    dans l’application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse26"
                    aria-expanded="false"
                    aria-controls="flush-collapse26"
                  >
                    <b>Est-il permis de fumer dans le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse26"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading26"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. Il est strictement interdit de fumer dans tous nos
                    véhicules. Des frais de nettoyage seront ajoutés à votre
                    facture si des traces de tabagisme sont constatées pendant
                    votre location.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row shadow-lg p-3 mb-5 bg-body rounded">
          <a href="https:/l.ead.me/beWm77">
            <img
              className="img-fluid rounded-4"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/App_Banner-new-format%20DE.png"
              alt=""
              style={{
                width: "100vw",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          </a>
        </div>
      </div>
    </>
  );
}

export default CHFrFAQBody;
